import React, { useState, useEffect } from 'react';
import { scrollToElement } from '../utils/transitions';
import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '../store/useSettingsStore';
import MobileMenu from './MobileMenu';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t } = useTranslation();
  const { language } = useSettingsStore();
  
  // Liste des sections pour la navigation - ajout de 'services'
  const sections = ['home', 'about', 'certifications', 'projects', 'experience', 'services', 'contact'];
  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const handleNavClick = (id: string) => {
    // Handle special case for home/accueil
    if (id === 'home') {
      scrollToElement('hero', 80);
    } else {
      scrollToElement(id, 80);
    }
  };

  const translateSection = (section: string) => {
    if (language === 'fr') {
      switch (section) {
        case 'home': return 'Accueil';
        case 'about': return 'À propos';
        case 'certifications': return 'Certifications';
        case 'projects': return 'Projets';
        case 'experience': return 'Expérience';
        case 'services': return 'Mes services';
        case 'contact': return 'Contact';
        default: return section;
      }
    } else {
      switch (section) {
        case 'home': return 'Home';
        case 'about': return 'About';
        case 'certifications': return 'Certifications';
        case 'projects': return 'Projects';
        case 'experience': return 'Experience';
        case 'services': return 'My Services';
        case 'contact': return 'Contact';
        default: return section;
      }
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-30 px-4 sm:px-6 md:px-12 transition-all duration-700 ease-cinematic ${
        isScrolled ? 'py-3 glass-morphism backdrop-blur-lg' : 'py-5 bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <button 
          className="text-xl md:text-2xl font-medium tracking-tighter hover:text-primary transition-colors duration-300"
          onClick={() => handleNavClick('home')}
        >
          nassim<span className="text-cyan-400 font-bold">.portfolio</span>
        </button>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {sections.slice(1).map((item) => (
            <button
              key={item}
              className="text-sm uppercase tracking-wider hover:text-primary transition-colors duration-300 link-hover"
              onClick={() => handleNavClick(item)}
            >
              {translateSection(item)}
            </button>
          ))}
        </nav>
        
        {/* Mobile Menu */}
        <div className="md:hidden">
          <MobileMenu sections={sections} />
        </div>
      </div>
    </header>
  );
};

export default Navbar;
